import { modelOptions, prop } from '@typegoose/typegoose';
import * as mongoose from 'mongoose';

class Endpoint {
  @prop({ required: true })
  id: mongoose.Types.ObjectId;
}

class EdrSpecifics {
  @prop({ required: false })
  category: number;

  @prop({ required: false, type: Endpoint })
  endpoint: Endpoint;

  @prop({ required: false })
  nodesCategories : Array<string>;
}

@modelOptions({ schemaOptions: { collection: 'securityIncidents' }, options: { customName: 'securityIncidents' } })
export class IncidentsModel {
  @prop({ required: true })
  type: number;

  @prop({ required: true, _id: false, type: EdrSpecifics })
  specifics: EdrSpecifics;

  @prop({ required: true })
  lastUpdated: Date;
}

export const INCIDENT_TYPE_EDR = 2;
